export default __webpack_public_path__ + "static/media/05.0619c46e.jpg";